'use client'

import { usePageData } from '@/contexts/PageDataContext'
import type { ImageData, Maybe } from '@/frontend-types'
import { tagCMSBlock } from '@/helpers/layout'
import { cx } from 'cva'
import Image from 'next/image'
import type { FC } from 'react'
import { Corridor } from '../atoms/Corridor'
import { Grid } from '../atoms/Grid'
import { PlaceholderImage } from '../atoms/PlaceholderImage'
import Breadcrumb from '../molecules/Breadcrumb'
import PageHeadSecondaryAssets from '../molecules/PageHeadSecondaryAssets'

export type PageHeadSecondaryType = {
	title: Maybe<string>
	image?: ImageData
}

const PageHeadSecondary: FC<PageHeadSecondaryType> = ({ title, image }) => {
	const pageData = usePageData()
	const titleOrPageTitle = title || pageData.title

	const imageWidth = 'tablet-p:w-[calc(100%-120px)] desktop:w-[calc(100%-160px)]'

	return (
		<section className={tagCMSBlock(['hero'])}>
			<div className="relative z-10 min-h-70 tablet-p:h-auto tablet-p:min-h-auto flex flex-col justify-end">
				<Corridor className="tablet-p:absolute tablet-p:inset-0">
					<div className="relative h-full w-full">
						<Grid className="tablet-p:absolute tablet-p:bottom-0 tablet-p:left-0 tablet-p:z-10 pt-7xl pb-5xl">
							<div className="relative z-10 col-span-full flex flex-row items-end gap-y-xl tablet-p:col-span-6 tablet-l:col-span-11">
								<h1 className="text-h1 text-white">{titleOrPageTitle}</h1>
							</div>
						</Grid>
					</div>
				</Corridor>
				<div className="absolute bottom-0 left-0 z-0 h-full w-full" aria-hidden="true">
					{/* Background image */}
					<div className={cx('relative h-full', imageWidth)}>
						{image ? (
							<Image
								src={image.src}
								alt={image.alt}
								fill
								className="object-cover"
								sizes="(max-width: 1559px) 95vw, 1500px"
							/>
						) : (
							<PlaceholderImage />
						)}
					</div>
					{/* Black overlay */}
					<div
						className="absolute inset-0 bg-black opacity-20 tablet-l:opacity-30 z-5 pointer-events-none"
						aria-hidden="true"
					/>
				</div>

				{/* SVG assets */}
				<PageHeadSecondaryAssets />
			</div>
			<Corridor className="pt-xl pb-6xl">
				<Breadcrumb />
			</Corridor>
		</section>
	)
}

export default PageHeadSecondary
